import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  outOfDateIE: boolean = false;
  versionIE: any;

  constructor () {
    if (this.isIE()) {
      this.outOfDateIE = true;
    };
  }

  isIE() {
    const match = navigator.userAgent.search(/(?:Edge|MSIE|Trident\/.*; rv:)/);
    let isIE = false;
    if (match !== -1) {
        isIE = true;
    }
    var IEVersion = ((navigator.userAgent.match(/(?:MSIE |Trident.*rv:|Edge\/)(\d+(\.\d+)?)/)) || []) [1]
    this.versionIE = IEVersion;
    this.versionIE = parseInt(this.versionIE);
    if (this.versionIE > 10) {
      isIE = false;
    }
    return isIE
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts